import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "./ui/button";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

interface OfferCardProps {
  bgImage: string;
  title: string;
  descTop: string;
  descMiddle?: string;
  descBottom?: string;
  descHide?: string;
  url: string;
  isRedirect?: boolean;
}

const OfferCard: React.FC<OfferCardProps> = ({
  bgImage,
  title,
  descTop,
  descMiddle,
  descBottom,
  descHide,
  url,
  isRedirect = false,
}) => {
  // Ensure the bgImage is properly formatted as a URL
  const backgroundImageUrl = bgImage?.startsWith('http') || bgImage?.startsWith('/') 
    ? bgImage 
    : `/images/${bgImage}`;

  const handleOfferClick = () => {
    if (!url) {
      return;
    }

    if (isRedirect) {
      window.location.href = url;
    } else {
      window.open(url);
    }
  };

  return (
    <>
      <div
        className={`rounded-sm pt-4 md:block hidden group overflow-hidden bg-cover bg-center`}
        style={{backgroundImage: `url(${backgroundImageUrl})`}}
      >
        <div className="bg-red-600 h-18 w-24 p-2 mx-4 mt-4 mb-8 rounded-md text-white text-xs">
          <p>{descTop}</p>
          <p className="font-bold text-base">{descMiddle}</p>
          <p>{descBottom}</p>
        </div>
        <p className="text-white font-bold text-xl translate-y-14 group-hover:translate-y-1 group-hover:ease-in group-hover:duration-300 group-hover:text-lg mx-4">
          {title}
        </p>
        <div className="bg-gray-50 p-4 group-hover:duration-300 group-hover:ease-in group-hover:translate-y-1 transition translate-y-20 flex flex-row items-center space-x-2">
          <p className="text-gray-500 text-sm">{descHide}</p>
          <Button onClick={handleOfferClick}>
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        </div>
      </div>
      <button
        type="button"
        onClick={handleOfferClick}
        className="md:hidden flex w-full flex-row items-center space-x-4 text-left"
      >
        <div className="bg-red-600 h-auto w-1/4 p-2 rounded-md text-white text-xs">
          <p>{descTop}</p>
          <p className="font-bold text-base">{descMiddle}</p>
          <p>{descBottom}</p>
        </div>
        <p className="font-bold text-xl">{title}</p>
      </button>
    </>
  );
};

export default OfferCard;
